import { Box, makeStyles, Typography } from '@material-ui/core';

import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    '& h3': {
      color: theme.palette.common.white,
      fontWeight: 600,
    },
  },
  skeletonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
    borderRadius: 8,
    width: '100%',
    background: theme.palette.safevideo.dark,
    '& #one, #two, #three': {
      borderRadius: theme.shape.borderRadius,
      background: theme.palette.dark[600],
    },
    '& #one': {
      width: 316,
      height: 28,
    },
    '& #two': {
      height: 24,
      width: 62,
    },
    '& #three': {
      height: 16,
      width: 66,
    },
  },
}));

const SkeletonModule = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Box marginBottom={4} component='span'>
        <Typography variant='h3'>Módulos</Typography>
      </Box>
      <div className={classes.skeletonContainer}>
        <Box>
          <Skeleton id='one' variant='rect' animation='wave' />
          <Box marginTop={2}>
            <Skeleton id='two' variant='rect' animation='wave' />
          </Box>
        </Box>
        <Skeleton id='three' variant='rect' animation='wave' />
      </div>

      <div className={classes.skeletonContainer}>
        <Box>
          <Skeleton id='one' variant='rect' animation='wave' />
          <Box marginTop={2}>
            <Skeleton id='two' variant='rect' animation='wave' />
          </Box>
        </Box>
        <Skeleton id='three' variant='rect' animation='wave' />
      </div>
    </div>
  );
};

export default SkeletonModule;
